export default "__VITE_ASSET__BeJBTOrt__"